/**
 * A very simple pub-sub channel for communicating globally between frontend components.
 */

import EventEmitter from 'eventemitter3'

const eventEmitter = new EventEmitter()

export type Event = 'navigated' | 'show-toast' | 'meeting-topic-updated' | 'came-online' | 'went-offline'

export function subscribe(event: Event, callback: (val: any) => void) {
  eventEmitter.on(event, callback)
}

export function unsubscribe(event: Event, callback: (val: any) => void) {
  eventEmitter.off(event, callback)
}

export function publish(event: Event, val: any) {
  eventEmitter.emit(event, val)
}
